import magnifiAPIInstance from "./apiInstance";

export const tagsAPIs = {
  getTags: ({ payload }) => magnifiAPIInstance.post(`/tags`, payload),
  createTags: ({ payload }) => magnifiAPIInstance.post(`/tag/create`, payload),
  editTags: ({ payload }) => magnifiAPIInstance.post(`/tag/edit`, payload),
  deleteTags: ({ payload }) => magnifiAPIInstance.post(`/tags/delete`, payload),
  addTagThroughCsv: ({ payload }) => magnifiAPIInstance.post(`/tag/upload-through-csv`, payload),
  validateAddTagThroughCsv: ({ payload }) => magnifiAPIInstance.post(`/tag/validate/csv`, payload),
  createBulkTags: ({ payload }) => magnifiAPIInstance.post(`/tag/create/many`, payload),
  updateImageTags: ({ payload }) => magnifiAPIInstance.patch(`/tag/update-image-tags`, payload),
  checkImgNameAvailability: ({ payload }) => magnifiAPIInstance.post(`/tag/check-imgName-availability`, payload),
  createCombinedTagsThroughCsv: ({ payload }) => magnifiAPIInstance.post(`/api/v3/bulk-upload/combined`, payload),
};
